import { useContext } from 'react';
import { useHistory } from 'react-router';
import WidgetPage from '.';
import { AnalyticsContext } from '../../ModularReduxAnalytics';
import { useApp, useAppDispatchers } from '../../state/app';
import { useToggles, useToggleDispatchers } from '../../state/toggles';
import { useUser, useUserDispatchers } from '../../state/user';

const WidgetPageContainer = props => {
  const { segment, analytics } = useContext(AnalyticsContext);
  const history = useHistory();
  const user = useUser();
  const app = useApp();
  const toggles = useToggles();
  const appActions = useAppDispatchers();
  const userActions = useUserDispatchers();
  const toggleActions = useToggleDispatchers();

  const stateProps = {
    user,
    app,
    toggles,
    ...appActions,
    ...userActions,
    ...toggleActions
  };

  return (
    <WidgetPage
      {...props}
      {...stateProps}
      segment={segment}
      analytics={analytics}
      history={history}
    />
  );
};

export default WidgetPageContainer;
